import { useQuery } from "@tanstack/react-query";
import { fetchWithAuth } from "./useAuth";

export interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  stock: number;
  hide: boolean;
  images: string[];
  imageUrl?: string;
  imageUrlOnPage?: string;
  pages?: number;
  categoryId?: number;
  cod?: number;
  isbn?: string;
  createdAt: string;
  updatedAt: string;
}

type ProductsResponse = Product[];

export function useProducts(options?: { enabled?: boolean }) {
  return useQuery<ProductsResponse, Error>({
    queryKey: ["products"],
    enabled: options?.enabled,
    queryFn: async () => {
      const response = await fetchWithAuth(`/api/admin/products`);
      if (!response.ok) throw new Error("Eroare la încărcarea produselor");
      return (await response.json()) as ProductsResponse;
    },
  });
}

